<ng-container *ngIf="type === 'horizontal'">
  <div class="horizontal-stepper">
    <div class="progress-grid" *ngFor="let step of data; let i = index; let last = last;">
      <div class="{{ last ? 'progress-last-item' : 'progress-item' }}">
        <div class="progress-step">
          <ng-container *ngTemplateOutlet="stepContent"></ng-container>
        </div>
      </div>
      <ng-template #stepContent>
        <div class="progress-container">
          <img class="progress-complete" src="assets/images/inProgress.svg" alt *ngIf="step.status === 'inProgress'" />
          <img class="progress-complete" src="assets/images/correct.png" alt *ngIf="step.status === 'completed'" />
          <span class="progress-status" [ngClass]="{ 'inactive' : step.status === 'yetToStart' }"
            *ngIf="step.status !== 'completed' && step.status !== 'inProgress'">
          </span>
        </div>
        <p class="progress-title"> {{step.name}} </p>
      </ng-template>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === 'vertical'">
  <div class="vertical-stepper">
    <div *ngFor="let step of data; let i = index;">
      <div class="vertical-line" *ngIf="i !== 0"></div>
      <div class="progress-container">
        <img class="progress-complete" src="assets/images/inProgress.svg" alt *ngIf="step.status === 'inProgress'" />
        <img class="progress-complete" src="assets/images/correct.png" alt *ngIf="step.status === 'completed'" />
        <span class="progress-status" [ngClass]="{ 'inactive' : step.status === 'yetToStart' }"
          *ngIf="step.status !== 'completed' && step.status !== 'inProgress'">
        </span>
      </div>
      <p class="progress-title"> {{step.name}} </p>
    </div>
  </div>
</ng-container>